module.exports = "/assets/logo_sg_lightroom_1_1_cc-ef157c5a03f2a73335199c415923c37a.png";